import { createTheme } from '@mui/material/styles'
import LatoBlack from '@/shared/assets/fonts/Lato-Black.woff2'
import LatoBold from '@/shared/assets/fonts/Lato-Bold.woff2'
import LatoMedium from '@/shared/assets/fonts/Lato-Medium.woff2'
import LatoRegular from '@/shared/assets/fonts/Lato-Regular.woff2'
import LatoSemibold from '@/shared/assets/fonts/Lato-Semibold.woff2'
export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(255, 193, 3, 1)',
      dark: 'rgba(234, 168, 0, 1)',
    },
    secondary: {
      main: 'rgba(245, 245, 246, 1)',
      dark: 'rgba(236, 236, 237, 1)',
    },
    info: {
      main: 'rgba(63, 104, 255, 1)',
      dark: 'rgba(29, 58, 255, 1)',
      light: 'rgba(185, 215, 255, 1)',
    },
    text: {
      primary: 'rgba(30, 30, 30, 1)',
    },
    background: {
      default: 'rgba(255, 255, 255, 1)',
    },
    success: {
      main: 'rgba(33, 152, 81, 1)',
      light: 'rgba(241, 252, 244, 1)',
      dark: 'rgba(30, 119, 66, 1)',
    },
    error: {
      main: 'rgba(244, 63, 63, 1)',
      light: 'rgba(254, 163, 163, 1)',
      dark: 'rgba(189, 24, 24, 1)',
    },
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
    fontSize: 16,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '28px',
          fontWeight: 600,
          lineHeight: '120%',
        },
        body1: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '150%',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(230, 230, 231, 1)',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Lato'), local('Lato-Regular'), url(${LatoRegular}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Lato'), local('Lato-Medium'), url(${LatoMedium}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 600;
          src: local('Lato'), local('Lato-Semibold'), url(${LatoSemibold}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 800;
          src: local('Lato'), local('Lato-Black'), url(${LatoBlack}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Lato';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Lato'), local('Lato-Bold'), url(${LatoBold}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
})
